import React from "react";

function About() {
  return <h1 className="about">About</h1>;
}

export default About;
